import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Container, CssBaseline, Grid, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ImNotification } from 'react-icons/im';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageHeading from '../../global/header/PageHeading';
import WebcamCaptureDocFront from '../CameraComponents/WebcamCaptureDoc';

import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import { userDataFromLocal } from '../utils/getUserDetails';
import DialogMsgAction from '../../global/DialogMsgAction';
import DialogMsg from '../../global/DialogMsg';
import { getScreenShots } from '../utils/MakePdf';
import WebcamCaptureFullMode from '../CameraComponents/WebcamCaptureFullMode';
import { useTranslation } from 'react-i18next';

const { GetOCR, UploadImage, GetRetakes, GetDocList, GetKYCListByDoc } = onBoardingEkycServices;

const DocumentPhoto = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  // const [heading, setHeading] = useState('Document Instruction AADHAR (Front)');
  const [heading, setHeading] = useState('');
  const [showFrontCamera, setShowFrontCamera] = useState(false);
  const [showBackSideCamera, setShowBackSideCamera] = useState(false);
  const [isBackSideScreen, setIsBackSideScreen] = useState(false); // State to backside screen to show hide
  const [isOcr, setIsOcr] = useState(false); // OCR done or not check
  const [bothSidePreview, setBothSidePreview] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  // Webcam ref and state to aadhaar
  const documentCameraRef = useRef();
  const [imageSrc, setImageSrc] = useState(null); // front side
  const [imageSrcBack, setImageSrcBack] = useState(null); // back side if is it
  // console.log('imageSrc2', imageSrc);
  // console.log('imageSrc2', imageSrcBack);
  // console.log('showFrontCamera', showFrontCamera, showBackSideCamera, isBackSideScreen);

  const pathData = useLocation();
  // console.log('pathData', pathData);
  const [docList, setDocList] = useState([]);
  const [getKYCListByDoc, setGetKYCListByDoc] = useState([]);

  // console.log('filteredArray', docList, getKYCListByDoc);

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  const docCode = urlParams.get('document_code');
  const sideFlag = urlParams.get('side_flag');
  const docName = urlParams.get('document_name');
  const ocrType = urlParams.get('ocrType');

  // make base64 to blob image (no need covert here converting at camera page allready)
  // const blobfun = (image, fileMode) => {
  //   console.log('jhbjhjknkk', image);

  //   const userData = userDataFromLocal();
  //   const applicationNo = userData?.applicationNo;
  //   const docNameReadable = docName.replace(/ /g, '_').toLowerCase();
  //   const file = new File([image], `${docNameReadable}_${fileMode}_${applicationNo}.jpg`, {
  //     type: image.type,
  //     lastModified: new Date().getTime()
  //   });
  //   // console.log('filesss', file);
  //   return file;
  // };

  // fireOcrApi (GetOCR) API
  const fireOcrApi = async () => {
    try {
      const userData = userDataFromLocal();
      const applicationNo = userData?.applicationNo;
      console.log('applicationNo', applicationNo);
      setOpenloader(true);

      const formOcr = new FormData();
      formOcr.append('channel', 'W');
      // formOcr.append('docType', 1);
      formOcr.append('docType', id);
      formOcr.append('applicationNo', applicationNo);
      formOcr.append('file', imageSrc?.file);
      if (Number(sideFlag) === 1) {
        formOcr.append('fileback', imageSrcBack?.file);
      }

      formOcr.append('countryId', 1);
      formOcr.append('languageId', 1);

      const GetOCRResponse = await GetOCR(formOcr);
      if (GetOCRResponse.status === 'Success' && GetOCRResponse.data !== null) {
        // dialogMsgHandler();
        // setDialogMsg('Data not found');

        // Check if 'existingJourney' exists in local storage, parse it from JSON, or initialize as an empty object
        let existingJourney = localStorage.getItem('journey');
        existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
        // Create a new object 'newData' to store updated journey data
        let newData = {};
        // Check the value of 'ocrType'
        // if (ocrType === 'NonOcr') {
        //   // If 'ocrType' is 'NonOcr', update the 'NonOCR' section of 'newData'
        //   newData = {
        //     ...existingJourney,
        //     NonOCR: {
        //       ...(existingJourney?.NonOCR || {}),
        //       [`doc_${docName.replace(/ /g, '_').toLowerCase()}`]: {
        //         ...(existingJourney?.NonOCR?.[`doc_${docName.replace(/ /g, '_').toLowerCase()}`] ||
        //           {}),
        //         ...GetOCRResponse.data
        //       }
        //     }
        //   };
        // }

        // else {
        // If 'ocrType' is not 'NonOcr', update the 'OCR' section of 'newData'
        newData = {
          ...existingJourney,

          OCR: {
            ...(existingJourney?.OCR || {}),
            [`doc_${docName.replace(/ /g, '_').toLowerCase()}`]: {
              ...(existingJourney?.OCR?.[`doc_${docName.replace(/ /g, '_').toLowerCase()}`] || {}),
              ...GetOCRResponse.data
            }
          }
        };
        //  }

        // Save the updated 'newData' object in local storage as 'journey'
        localStorage.setItem('journey', JSON.stringify(newData));
        // setIsOcr(true);
        GetKYCListByDocApi(id); // check other documents is exist or not, api fired when OCR=true and success
      } else if (
        GetOCRResponse.status === 'Success' &&
        ocrType === 'ocr' &&
        !GetOCRResponse?.data?.length > 0
      ) {
        setOpenDialogeMsg(true);
        setDialogMsg('The system cannot be verified. Please try again.');
        // setDialogMsg('Something went wrong');
      } else if (
        GetOCRResponse.status.toLowerCase() === 'failure' ||
        GetOCRResponse.status.toLowerCase() === 'failed'
      ) {
        setOpenDialogeMsg(true);
        setDialogMsg(t('OCR not done. Please retake again'));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };
  // dialog open
  const dialogMsgHandler = () => {
    setOpenDialog(true);
  };
  // dialog close
  const handleCloseConfirmBox = () => {
    setOpenDialog(false);
  };

  const handleClickOpen = (frontBackside) => {
    if (frontBackside === 'frontSide') {
      setShowFrontCamera(true);
      setShowBackSideCamera(false);

      // setHeading('Document preview');
    } else if (frontBackside === 'backSide') {
      setShowBackSideCamera(true);
      setShowFrontCamera(false);
      setIsBackSideScreen(false); // used to backside screen show hide
    }

    // setOpen(true);
  };

  // Dialog close button of camera
  const iconButtonHandler = (e) => {
    setShowFrontCamera(false);
    setShowBackSideCamera(false);
    setIsBackSideScreen(true); // used to backside screen show hide
  };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  // function used to delay due to getscreenshot taking time as promise
  const UploadImageApiCallBack = async (canvasId, sideAngle) => {
    // console.log('getCanvasgetCanvas', canvasId, type);

    const getCanvas = await getScreenShots(canvasId);
    getCanvas.toBlob(function (blob) {
      UploadImageApi(blob, sideAngle);
      // console.log('getCanvasgetCanvas', blob);
      const fileReader = new FileReader();
      // console.log('getCanvasgetCanvas', fileReader);
      fileReader.onload = function (event) {
        const base64String = event.target.result;
        // console.log('getCanvasgetCanvas', base64String);
        // UploadImageApi(base64String, sideAngle);
      };
      fileReader.readAsDataURL(blob);
    });
  };

  const UploadImageApi = async (watermarkFile, sideAngle) => {
    console.log('getCanvasgetCanvas', watermarkFile, sideAngle);
    const urlParams = new URLSearchParams(window.location.search);
    const docCode = urlParams.get('document_code');
    const newFile = new File([watermarkFile], `DocWithWatermark_${docCode}_${sideAngle}.jpg`, {
      type: 'image/jpg',
      lastModified: new Date().getTime()
    });
    // console.log('getCanvasgetCanvas', newFile);

    try {
      // console.log('base64data', watermarkFile);
      const userData = userDataFromLocal();
      const applicationNo = userData?.applicationNo;
      console.log('applicationNo', applicationNo);
      setOpenloader(true);
      const formOcr = new FormData();
      formOcr.append('channelName', 'W');
      formOcr.append('docId', id);
      formOcr.append('docType', ocrType === 'NonOcr' ? 'NONOCR' : 'DocWaterMark'); // SelfiWDWaterMark, NONOCR
      formOcr.append('organizationId', 1);
      formOcr.append('applicationNo', applicationNo);
      formOcr.append('file', newFile ? newFile : null);
      formOcr.append('isWatermarked', true);
      formOcr.append('isBackendImage', sideAngle === 'back' ? true : false);

      const headerCredential = {
        languageId: 1,
        countryId: 1
      };

      const UploadImageResponse = await UploadImage(headerCredential, formOcr);
      if (
        UploadImageResponse.status === 'Success' &&
        Object.keys(UploadImageResponse.data).length > 0
      ) {
        // Check if 'existingJourney' exists in local storage, parse it from JSON, or initialize as an empty object
        let existingJourney = localStorage.getItem('journey');
        existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
        // Create a new object 'newData' to store updated journey data
        let newData = {};

        // Check the value of 'ocrType'
        if (ocrType === 'NonOcr') {
          // If 'ocrType' is 'NonOcr', update the 'NonOCR' section of 'newData'
          newData = {
            ...existingJourney,
            NonOCR: {
              ...(existingJourney?.NonOCR || {}),
              [`doc_${docName.replace(/ /g, '_').toLowerCase()}`]: {
                ...(existingJourney?.NonOCR?.[`doc_${docName.replace(/ /g, '_').toLowerCase()}`] ||
                  {}),
                [`doc_url_${sideAngle}_${docName.replace(/ /g, '_').toLowerCase()}`]:
                  UploadImageResponse.data
              }
            }
          };
        } else {
          // If 'ocrType' is not 'NonOcr', update the 'OCR' section of 'newData'
          newData = {
            ...existingJourney,
            // OCR: {
            //   ...existingJourney?.OCR,
            //   [`doc_${docName.replace(/ /g, '_').toLowerCase()}`]: {

            //     [`doc_url_${sideAngle}_${docName.replace(/ /g, '_').toLowerCase()}`]:
            //       UploadImageResponse.data
            //   } // Use optional chaining to safely access nested properties
            // }

            OCR: {
              ...(existingJourney?.OCR || {}),
              [`doc_${docName.replace(/ /g, '_').toLowerCase()}`]: {
                ...(existingJourney?.OCR?.[`doc_${docName.replace(/ /g, '_').toLowerCase()}`] ||
                  {}),
                [`doc_url_${sideAngle}_${docName.replace(/ /g, '_').toLowerCase()}`]:
                  UploadImageResponse.data
              }
            }
          };
        }

        // Save the updated 'newData' object in local storage as 'journey'
        localStorage.setItem('journey', JSON.stringify(newData));
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(UploadImageResponse.message);
        // setDialogMsg('Something went wrong');
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };

  // RetakeApi
  const RetakeApi = async () => {
    try {
      setOpenloader(true);
      const GetRetakesResponse = await GetRetakes();
      if (GetRetakesResponse.status === 'Success') {
        navigate('/in/selfregistration');
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(GetRetakesResponse.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // GetDocListApi
  const GetDocListApi = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const ocrType = urlParams.get('ocrType');
      setOpenloader(true);
      const credential = { isOrcDocsList: ocrType === 'ocr' ? true : false };
      const GetDocListResponse = await GetDocList(credential);
      if (GetDocListResponse.status === 'Success') {
        if (GetDocListResponse.data.length > 0) {
          // const arrayFilter = GetDocListResponse.data.filter((item) => item?.parentFlag);
          setDocList(GetDocListResponse.data); // no need of filter, because require all data here
        } else {
          setOpenDialogeMsg(true);
          setDialogMsg('Data not found');
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // GetKYCListByDocApi
  // const GetKYCListByDocApi = async (documentId) => {
  const GetKYCListByDocApi = async (documentId) => {
    try {
      // const urlParams = new URLSearchParams(window.location.search);
      // const id = urlParams.get('id');
      setOpenloader(true);
      const credential = { docId: documentId };
      const GetKYCListByDocResponse = await GetKYCListByDoc(credential);
      if (GetKYCListByDocResponse.status === 'Success') {
        if (GetKYCListByDocResponse?.data?.length > 0) {
          // Call the function and log the result
          const filteredArray = docList.filter((arr1Item) =>
            GetKYCListByDocResponse.data.some((arr2Item) => arr2Item.childId === arr1Item.id)
          )[0];
          if (filteredArray) {
            console.log('filteredArray', filteredArray);
            const urlParams = `?id=${filteredArray.id}&document_code=${filteredArray.documentCode}&document_name=${filteredArray.documentName}&side_flag=${filteredArray.sideFlage}&ocrType=${ocrType}`;
            setBothSidePreview(false);
            setShowFrontCamera(false);
            setImageSrc(null);
            setImageSrcBack(null);

            navigate(`/in/document-photo/${urlParams}`);
          }
          // setGetKYCListByDoc(filteredArray);
        }
      } else if (
        GetKYCListByDocResponse.status === 'Failure' &&
        GetKYCListByDocResponse.data === null
      ) {
        // navigate to  document choose with false non ocr  , in query params
        if (ocrType === 'NonOcr') {
          navigate(`/in/document-with-selfie`);
        } else {
          navigate(`/in/document-choose/?ocrType=false`);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // Dialog Retake photo
  const handleRetackPhoto = (frontBackside) => {
    if (frontBackside === 'frontSide') {
      setShowFrontCamera(true);
      setImageSrc(null);
    } else if (frontBackside === 'backSide') {
      setShowBackSideCamera(true);
      setImageSrcBack(null);
    } else if (frontBackside === 'starting') {
      setImageSrc(null);
      setImageSrcBack(null);
      setShowFrontCamera(false);
      setShowBackSideCamera(false);
      setBothSidePreview(false);
    }
    // RetakeApi();
  };
  // Dialog handle continue
  const handlContinue = (frontBackside) => {
    // if slideFlage 1 then doc have front back otherwise only front
    if (Number(sideFlag) === 1) {
      if (frontBackside === 'backSide') {
        setShowBackSideCamera(true);
        setIsBackSideScreen(true);
      } else if (frontBackside === 'finalPreview') {
        setBothSidePreview(true);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // Heading Title text change only
    if (imageSrc !== null && isBackSideScreen === false) {
      setHeading(t('Document preview'));
    } else if (
      imageSrc !== null &&
      showFrontCamera === false &&
      imageSrcBack === null &&
      isBackSideScreen === true
    ) {
      setHeading(`${t('Document Instructions')} ${t(docName)} (${t('Back')})`);
    } else {
      setHeading(`${t('Document Instructions')} ${t(docName)} (${t('Front')})`);
    }
  }, [showFrontCamera, isBackSideScreen, heading, docName]);

  useEffect(() => {
    GetDocListApi(); // need to call again to check next list or not.
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle={t(heading)} />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        {/* Scan the first front */}
        {imageSrc === null && showFrontCamera === false ? (
          <FrontSideComponent handleClickOpen={handleClickOpen} />
        ) : imageSrc !== null &&
          showFrontCamera === false &&
          imageSrcBack === null &&
          isBackSideScreen === true ? (
          <BackSideComponent handleClickOpen={handleClickOpen} />
        ) : (
          ''
        )}
        {/* Here camera component conditionally open to front or back side */}
        {showFrontCamera ? (
          ocrType === 'NonOcr' ? (
            <Box className="docPhotoFullModeStyle">
              <WebcamCaptureFullMode
                imageSrc={imageSrc}
                setImageSrc={setImageSrc}
                setShowFrontCamera={setShowFrontCamera}
                iconButtonHandler={iconButtonHandler}
                fileMode="front"
                heading={docName}
              />
            </Box>
          ) : (
            <Box className="docPhotoStyle">
              <WebcamCaptureDocFront
                documentCameraRef={documentCameraRef}
                setImageSrc={setImageSrc}
                setShowFrontCamera={setShowFrontCamera}
                iconButtonHandler={iconButtonHandler}
                fileMode="front"
                heading={docName}
                // fireOcrApi={fireOcrApi}
              />
            </Box>
          )
        ) : imageSrc !== null &&
          showFrontCamera === false &&
          imageSrcBack === null &&
          showBackSideCamera === true &&
          isBackSideScreen === false ? (
          <Box className="docPhotoStyle">
            <WebcamCaptureDocFront
              documentCameraRef={documentCameraRef}
              setImageSrc={setImageSrcBack}
              setShowFrontCamera={setShowBackSideCamera}
              iconButtonHandler={iconButtonHandler}
              fileMode="back"
              heading={docName}
              // fireOcrApi={fireOcrApi}
            />
          </Box>
        ) : (
          ''
        )}
        {/* Image preview */}
        {imageSrc !== null &&
        showFrontCamera === false &&
        imageSrcBack === null &&
        showBackSideCamera === false &&
        isBackSideScreen === false ? (
          <FrontSidePreviewComponent
            handlContinue={handlContinue}
            handleRetackPhoto={handleRetackPhoto}
            imageSrc={imageSrc}
            fireOcrApi={fireOcrApi}
            GetKYCListByDocApi={GetKYCListByDocApi} // check other documents is exist or not
            UploadImageApiCallBack={UploadImageApiCallBack} // fire upload image api to get URL of watermark pic
          />
        ) : imageSrc !== null && imageSrcBack !== null && bothSidePreview === false ? (
          <BackSidePreviewComponent
            handlContinue={handlContinue}
            handleRetackPhoto={handleRetackPhoto}
            imageSrcBack={imageSrcBack}
            UploadImageApiCallBack={UploadImageApiCallBack} // fire upload image api to get URL of watermark pic
          />
        ) : bothSidePreview === true ? (
          <BothSidePreviewComponent
            handleRetackPhoto={handleRetackPhoto}
            imageSrc={imageSrc}
            imageSrcBack={imageSrcBack}
            fireOcrApi={fireOcrApi}
            GetKYCListByDocApi={GetKYCListByDocApi} // check other documents is exist or not
          />
        ) : (
          ''
        )}

        {/* <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="popupYello"
        >
          <DialogTitle id="alert-dialog-title" className="popupYellowHeading">
            <Box className="popupIconBox">
              <ImNotification className="popupIcon" />
            </Box>
            <Typography variant="subtitle1" color="white">
              Error
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" className="popupBody">
              <Typography variant="subtitle1" className="popUpHeading" mb={2}>
                Try again!
              </Typography>
              <Typography variant="body1" className="popupContent" mb={2}>
                The picture is not clear.
              </Typography>
              <Typography variant="body1" className="popupContent">
                Please try again.
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="popupFooter">
            <Link className="mainBtn" to="/camera-document-front">
              Try again
            </Link>
          </DialogActions>
        </Dialog> */}

        <DialogMsgAction
          openDialogeMsg={openDialog}
          dialogMsg={dialogMsg}
          dialogTitle="Confirmation"
          buttonText="Next"
          dialogMsgHandler={dialogMsgHandler}
          closeDialogMsgHandler={handleCloseConfirmBox}
        />

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Alert"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default DocumentPhoto;

function FrontSideComponent({ handleClickOpen }) {
  const { t } = useTranslation();

  return (
    <Box>
      <Box textAlign="center" mb={2}>
        <Box mb={3} className="imagePreviewBox">
          <img
            className="imagePreviewFrame2"
            src="/static/doucment_instruction.svg"
            alt="Take a Document Photo"
          />
        </Box>

        <Typography variant="h6" className="cameraTitle" mb={2}>
          {t('Scan the')} {t('front')}
        </Typography>
        <Typography variant="body2" mb={2}>
          {t('Take a photo of the front of your identity card')}
        </Typography>

        <Button
          className="mainBtn"
          onClick={() => {
            handleClickOpen('frontSide');
          }}
        >
          {t('Take a photo')}
        </Button>
      </Box>
    </Box>
  );
}
function BackSideComponent({ handleClickOpen }) {
  const { t } = useTranslation();

  return (
    <Box>
      <Box textAlign="center" mb={2}>
        <Box mb={3} className="imagePreviewBox">
          <img
            className="imagePreviewFrame2"
            src="/static/doucment_instruction.svg"
            alt="Take a Document Photo"
          />
        </Box>

        <Typography variant="h6" className="cameraTitle" mb={2}>
          {t('Scan the')} {t('back')}
        </Typography>
        <Typography variant="body2" mb={2}>
          {t('Take a photo of the back of your identity card')}
        </Typography>

        <Button
          className="mainBtn"
          onClick={() => {
            handleClickOpen('backSide');
          }}
        >
          {t('Take a photo')}
        </Button>
      </Box>
    </Box>
  );
}
function FrontSidePreviewComponent({
  handlContinue,
  UploadImageApiCallBack,
  handleRetackPhoto,
  imageSrc,
  GetKYCListByDocApi,
  fireOcrApi
}) {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  const sideFlag = urlParams.get('side_flag');
  const docName = urlParams.get('document_name');
  const ocrType = urlParams.get('ocrType');
  const { t } = useTranslation();

  return (
    <Box textAlign="center">
      <Box mb={3} className="imagePreviewBox patent">
        <img
          id="sendWatermarkImage"
          className="imagePreviewFrame"
          src={imageSrc?.img}
          alt="Document front Preview"
        />
      </Box>
      <Box Container justifyContent="center" alignItems="center">
        <Button
          onClick={() => {
            UploadImageApiCallBack('#sendWatermarkImage', 'front');

            setTimeout(() => {
              if (Number(sideFlag) === 1) {
                handlContinue('backSide');
              } else {
                // GetKYCListByDocApi(id); // check other documents is exist or not
                if (ocrType === 'ocr') {
                  fireOcrApi();
                } else if (ocrType === 'NonOcr') {
                  GetKYCListByDocApi(id); // check other documents is exist or not
                  // Check if 'existingJourney' exists in local storage, parse it from JSON, or initialize as an empty object
                  let existingJourney = localStorage.getItem('journey');
                  existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
                  const newData = {};
                  // If 'ocrType' is 'NonOcr', update the 'NonOCR' section of 'newData'
                  newData = {
                    ...existingJourney,
                    NonOCR: {
                      ...(existingJourney?.NonOCR || {}),
                      [`doc_${docName.replace(/ /g, '_').toLowerCase()}`]: {
                        ...(existingJourney?.NonOCR?.[
                          `doc_${docName.replace(/ /g, '_').toLowerCase()}`
                        ] || {})
                      }
                    }
                  };
                  // Save the updated 'newData' object in local storage as 'journey'
                  localStorage.setItem('journey', JSON.stringify(newData));
                }
                // UploadImageApiCallBack(); // upload image api call
              }
            }, 500);
          }}
          className="mainBtn btnLink"
          style={{ marginRight: '7px' }}
        >
          {t('Continue')}
        </Button>
        <Button onClick={() => handleRetackPhoto('frontSide')} className="mainBtn btnLink">
          {t('Retake')}
        </Button>
      </Box>
    </Box>
  );
}
function BackSidePreviewComponent({
  handlContinue,
  handleRetackPhoto,
  imageSrcBack,
  UploadImageApiCallBack
}) {
  const { t } = useTranslation();

  return (
    <Box textAlign="center">
      {/* {alert('backSide')} */}
      <Box mb={3} id="sendWatermarkImageBack" className="imagePreviewBox patent">
        <img className="imagePreviewFrame" src={imageSrcBack?.img} alt="Document Preview" />
      </Box>
      <Box Container justifyContent="center" alignItems="center">
        <Button
          onClick={() => {
            UploadImageApiCallBack('#sendWatermarkImageBack', 'back');
            setTimeout(() => {
              handlContinue('finalPreview');
            }, 500);
          }}
          className="mainBtn btnLink"
          style={{ marginRight: '7px' }}
        >
          {t('Continue')}
        </Button>
        <Button onClick={() => handleRetackPhoto('backSide')} className="mainBtn btnLink">
          {t('Retake')}
        </Button>
      </Box>
    </Box>
  );
}
function BothSidePreviewComponent({
  handleRetackPhoto,
  imageSrc,
  imageSrcBack,
  GetKYCListByDocApi,
  fireOcrApi,
  UploadImageApiCallBack
}) {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  const sideFlag = urlParams.get('side_flag');
  const { t } = useTranslation();

  return (
    <Box textAlign="center">
      <Grid
        container
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs="auto">
          <Box mb={3} className="imagePreviewBox patent">
            <img className="imagePreviewFrame" src={imageSrc?.img} alt="Document Preview" />
          </Box>
        </Grid>
        <Grid item xs="auto">
          <Box mb={3} className="imagePreviewBox patent">
            <img className="imagePreviewFrame" src={imageSrcBack?.img} alt="Document Preview" />
          </Box>
        </Grid>
      </Grid>

      <Box Container justifyContent="center" alignItems="center">
        <Button
          onClick={() => {
            console.log('bothsidepagepreviewId', id, sideFlag);
            // GetKYCListByDocApi(id); // check other documents is exist or not

            fireOcrApi(); // Ocr data
            // upload image with waterMark
          }}
          className="mainBtn btnLink"
          style={{ marginRight: '7px' }}
        >
          {t('Continue')}
        </Button>
        {/* <Link to="/in/document-with-selfie" className="mainBtn btnLink">
          Continue
        </Link> */}
        <Button onClick={() => handleRetackPhoto('starting')} className="mainBtn btnLink">
          {t('Retake')}
        </Button>
      </Box>
    </Box>
  );
}
